import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { APICONFIG } from '@config/api.config';

interface DeletePresignedURLResponse {
	success: boolean;
	message: string;
}

interface DeletePresignedURLData {
	url: string;
}

interface DeletePresignedURL {
	mutate: UseMutateFunction<DeletePresignedURLResponse, Error, DeletePresignedURLData, unknown>;
	data?: DeletePresignedURLResponse;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

const deletePresignedURLData = async (data: DeletePresignedURLData): Promise<DeletePresignedURLResponse> => {
	return await APIService.postData<DeletePresignedURLResponse>(APICONFIG.PRESIGNED_URL_DELETE, data);
};

export const useDeletePresignedURL = (): DeletePresignedURL => {
	const { mutate, data, error, isError, isPending } = useMutation({
		mutationFn: deletePresignedURLData,
	});

	return {
		mutate,
		data,
		error,
		isError,
		isPending,
	};
};
